export default __webpack_public_path__ + "static/media/sort-arrow.8f84b391.svg";